<template>
  <div class="flex items-center gap-3 w-full py-1 px-3">
    <button @click="goBack()">
      <Icon icon="bx:chevron-left" />
    </button>
    <p class="text-lg font-medium text-center min-w-[54px]">
      {{currentNumber}} / {{ items.length }}
    </p>
    <div class="flex flex-grow gap-1">
      <div
        v-for="(item, index) in items"
        :key="index"
        :class="[
          'flex-1 rounded-md h-2',
          {
            'bg-blue-600': item.state === 'active',
            'bg-neutral-200': item.state === 'disabled',
            'bg-neutral-400': item.state === 'pending',
          },
        ]"
      ></div>
    </div>
    <button @click="goForward()" v-if="!onlyBack">
      <Icon icon="bx:chevron-right" />
    </button>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";

export default {
  name: "MobSteps",
  
  components: {
    Icon,
  },

  props: {
    allowNavigation: Boolean,
    items: Array,
    onlyBack: Boolean
  },

  data() {
    return {
      currentNumber: 1
    }
  },

  watch: {
    items: function () {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].state === 'active') {
          this.currentNumber = i + 1;
          break;
        }
      }
    }
  },

  methods: {
    goBack() {
      this.$emit('goBack')
    },
    
    goForward() {
      if (!this.onlyBack) {
        this.$emit('goForward')
      }
    }
  }
};
</script>
